import { Button, Flex, Typography, Tooltip, Badge, Dropdown } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { useStores } from "stores";
import { getFullName } from "utils";
import { routes } from "constants/routes";
import { HorizontalMenu } from "components/Menu/HorizontalMenu";
import { ReactComponent as LogoIcon } from "../../images/web3tech-logo.svg";
import UserIcon from "images/headerIcons/user.svg";
import SettingsIcon from "images/headerIcons/settings.svg";
import NotificationsIcon from "images/headerIcons/notifications.svg";
import { ReactComponent as SignOut } from "images/menuIcons/SignOut.svg";
import { BalancesBlock } from "./BalancesBlock";
import styles from "./header.module.css";
import { observer } from "mobx-react-lite";

interface IProps {
  showBack?: boolean;
}

export const Header = observer(({ showBack = false }: IProps) => {
  const { user, pendingStatistics, webSettings } = useStores();
  const hasPendingPage = pendingStatistics?.indicators?.total > 0;
  const navigate = useNavigate();

  function handleLogout() {
    user.error = "";
    user.logout();
  }

  const {
    isJuniorOperator,
    isSeniorOperator,
    isRiskManager,
    isProvider,
    isCustomer,
    isLPRiskManager,
    isUserAdmin,
    isSystemAdmin,
    isCompanyDocUploading,
    isPasswordChange,
    isJuniorCustomer,
    isOperator,
  } = user.roles;


  const showBalanceBlock = isSeniorOperator || isJuniorOperator || isRiskManager || isCustomer || isProvider || isLPRiskManager;

  const getHomeRoute = (): string => {
    if (isSeniorOperator || isJuniorOperator || isProvider || isCustomer || isLPRiskManager) {
      return `/${routes.pendingActions}`;
    }

    if (isUserAdmin) {
      return `/${routes.companies}`;
    }

    if (isRiskManager) {
      return `/${routes.bids}`;
    }

    if (isSystemAdmin) {
      return `/${routes.settings}`;
    }

    return `/${routes.pendingActions}`;
  };

  return (
    <Flex vertical>
      <Flex className={`${styles.header} ${styles.menuBlock}`}>
        <Flex>
          <Flex vertical align="center">
            {!webSettings.logo.statuses.fetchError ? (
              webSettings.logo.data ? (
                <img
                  src={webSettings.logo.data?.url}
                  className={`${styles.loginBackground} cursor-pointer`}
                  onClick={() => navigate(getHomeRoute() || "/")}
                  height="38px"
                  width="74px"
                />
              ) : null
            ) : (
              <LogoIcon
                className={`${styles.loginBackground} cursor-pointer`}
                onClick={() => navigate(getHomeRoute() || "/")}
                height="38px"
                width="74px"
              />
            )}
          </Flex>
        </Flex>

        <HorizontalMenu />

        {user.isAuthorized ? (
          <Flex>
            <Flex gap="12px">
              <Flex vertical align="end">
                <Typography.Text className={styles.userName}>{getFullName(user.userInfo)}</Typography.Text>
                <Typography.Text className={styles.userCompany}>{user.userInfo?.company_name}</Typography.Text>
                {/* {userCompanyRole && (
                      <Flex className={styles.userCompanyRoleBlock}>
                        <Status
                          color={COMPANY_ROLES.colors[userCompanyRole]}
                          children={COMPANY_ROLES.texts[userCompanyRole]}
                          className={styles.userCompanyRole}
                          uppercase={false}
                          withoutBorder
                        />
                      </Flex>
                    )} */}
              </Flex>
              <Dropdown
                overlayClassName={styles.profileDropdown}
                menu={{
                  items: [
                    {
                      key: "profile",
                      label: (
                        <Link to={`/${routes.profile}`} id="profile-link">
                          Мой профиль
                        </Link>
                      ),
                    },
                    {
                      key: "logout",
                      label: (
                        <Flex align="center" justify="space-between" className="full-width">
                          <span>Выйти</span>
                          <SignOut className={styles.logoutIcon} />
                        </Flex>
                      ),
                      onClick: handleLogout,
                    },
                  ],
                }}
                trigger={["click"]}
              >
                <Button
                  className={styles.headerCircleButton}
                  type="primary"
                  shape="circle"
                  size="large"
                  icon={<img src={UserIcon} />}
                />
              </Dropdown>

              <Tooltip title="Ожидают действий">
                <Link to={`/${routes.pendingActions}`} id="profile-link">
                  <Badge dot={hasPendingPage} color="green">
                    <Button
                      className={styles.headerCircleButton}
                      type="primary"
                      shape="circle"
                      size="large"
                      icon={<img src={NotificationsIcon} />}
                    />
                  </Badge>
                </Link>
              </Tooltip>
              <Tooltip title="Настройки">
                <Link to={`/${routes.settings}`} id="profile-link">
                  <Button
                    className={styles.headerCircleButton}
                    type="primary"
                    shape="circle"
                    size="large"
                    icon={<img src={SettingsIcon} />}
                  />
                </Link>
              </Tooltip>
            </Flex>
          </Flex>
        ) : null}
      </Flex>

      {showBalanceBlock && <BalancesBlock />}
    </Flex>
  );
});
